import PropTypes from "prop-types";
import { Modal, Button, CustomContainer } from "../DependencyHelper";
import { createMarkup, imagePrefix } from "../../../utils/helperServices";
import Image from "../image/image";
import styles from "./ConfirmModal.module.scss";

const ConfirmModal = ({
  show,
  title,
  text,
  subtext,
  cancelLabel,
  confirmLabel,
  handleCancel,
  handleConfirm,
  imageUrl,
}) => {

  const imagePath = (imageUrl) ? imageUrl : `${imagePrefix}/assets/images/icon-trash-active.svg`

  return (
    <>
      <Modal
        show={show}
        dialogClassName={`${styles["confirm-modal"]}`}
        onHide={handleCancel}
        centered
      >
        <Modal.Header className={styles["modal-header"]}>
          <Image
            className={styles["close-button"]}
            img_path={`${imagePrefix}/assets/images/modal-close.svg`}
            onClick={handleCancel}
          />
        </Modal.Header>
        <Modal.Body className={styles["modal-body"]}>
          <CustomContainer className={styles["trash-icon"]}>
            <Image
              img_path={imagePath}
            />
          </CustomContainer>
          <CustomContainer className={styles["title"]} id={`${title}-heading`}>
            {title}
          </CustomContainer>
          {subtext && (
            <CustomContainer
              className={styles["sub-content"]}
              dangerouslySetInnerHTML={createMarkup(subtext)}
            />
          )}
          <CustomContainer
            className={styles["content"]}
            dangerouslySetInnerHTML={createMarkup(text)}
            id={`${title}-desc`}
          />
        </Modal.Body>
        <Modal.Footer className={styles["modal-footer"]}>
          <Button
            onClick={handleConfirm}
            className={`${styles["sure"]}`}
            id={`${confirmLabel}-btn`}
          >
            {confirmLabel}
          </Button>
          <Button
            onClick={handleCancel}
            className={`${styles["cancel"]}`}
            id={`${cancelLabel}-btn`}
          >
            {cancelLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

ConfirmModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  subtext: PropTypes.string,
  text: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  imageUrl: PropTypes.string,
};

ConfirmModal.defaultProps = {
  title: "Are you sure?",
  cancelLabel: "No, cancel",
  confirmLabel: "Yes, I'm sure",
};

export default ConfirmModal;
